import { useEffect } from "react";

export default function useCheckoutStep(step) {
  useEffect(() => {
    if (!step) return;

    const params = new URLSearchParams(window.location.search);
    if (params.get("step") !== step) {
      params.set("step", step);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState(null, "", newUrl);
    }
  }, [step]);
}
